import type { UserT } from '@mentimeter/user';
import { type GetInvitesResponse } from '@core-api/workspace-members/workspace-members/invites/{token}';
import { JoinTeamErrorModalContent } from './JoinTeamErrorModalContent';
import { JoinTeamSuccessModalContent } from './JoinTeamSuccessModalContent';
import { JoinTeamConsent } from './require-action-from-user/JoinTeamConsent';
import type { ConsumeStatus } from './types';

export const JoinTeamModalContent = ({
  inviteDetails,
  user,
  consumeStatus,
  onSuccessActionClick,
  successActionText,
  onJoinWorkspaceClick,
  teamName,
  onDismiss,
  isLoading,
}: {
  inviteDetails: Omit<GetInvitesResponse, 'invitedEmail'>;
  user: UserT;
  consumeStatus: ConsumeStatus;
  successActionText: string;
  onSuccessActionClick: () => void;
  onJoinWorkspaceClick: () => void;
  teamName: string;
  onDismiss: () => void;
  isLoading: boolean;
}) => {
  if (consumeStatus.state === 'success') {
    return (
      <JoinTeamSuccessModalContent
        teamName={teamName}
        onActionClick={onSuccessActionClick}
        actionText={successActionText}
        role={inviteDetails.invitedRole}
      />
    );
  }

  if (consumeStatus.state === 'pending-consent') {
    return (
      <JoinTeamConsent
        onJoinWorkspaceClick={onJoinWorkspaceClick}
        user={user}
        isLoading={isLoading}
        onDismiss={onDismiss}
        newPlan={inviteDetails.workspacePlanFeatures}
        teamName={teamName}
        invitedRole={inviteDetails.invitedRole}
      />
    );
  }

  return (
    <JoinTeamErrorModalContent
      error={consumeStatus.error}
      teamName={teamName}
    />
  );
};
